import {connect} from "react-redux";
import FilterPageVehicleModel from "../../components/Filter/FilterPageVehicleModel";
import {withTranslation} from "react-i18next";
import type {ApplicationState} from "../../reducers";
import {setVehicle} from "../../actions/vehicle";
import {isVehicleKeyAncestor} from "../../helper/vehicleKey";

function mapStateToProps(state: ApplicationState, ownProps) {
	const {filter, subCategory} = state.filter;
	return {
		subCategory: subCategory,

		isModelSelected: modelKey => filter.vehicleModel === modelKey || isVehicleKeyAncestor(filter.vehicleKey, modelKey),
		isSeriesSelected: seriesKey => filter.vehicle === seriesKey || isVehicleKeyAncestor(filter.vehicleKey, seriesKey),
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		setVehicleSeries: vehicleSeriesKey => {
			dispatch(setVehicle(vehicleSeriesKey, null, "filter_menu"));
		},
		setVehicleModel: vehicleModelKey => {
			dispatch(setVehicle(null, vehicleModelKey, "filter_menu"));
		},
	};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FilterPageVehicleModel));
